import { utils } from '@blend/ui-common';

import { createNewLoan, CreateNewLoanParams } from 'login-apis/loansAPI';
import * as featureFlags from './featureFlags';
import * as userUtils from './userUtils';
import { WindowWrapper } from './globalWrappers';

// Create a new loan for the user if they are logged in
export function shouldAddNewLoanToBorrower(): boolean {
  // Backend attaches CURRENT_USER to the window if they are logged in
  return !!(featureFlags.isEnabled('applicationChooserInDropdownMenu20190109') && userUtils.getCurrentUser());
}

interface ModifiedCreateNewLoanParams extends Pick<CreateNewLoanParams, 'modelProperties'> {
  loanType: LoanType;
}

function modifyCreateLoanParams(params: ModifiedCreateNewLoanParams): CreateNewLoanParams {
  if (params.loanType === 'CONSTRUCTION') {
    params.loanType = 'MORTGAGE';
    params.modelProperties = { loanPurpose: 'CONSTRUCTION' };
  }
  return params as CreateNewLoanParams;
}

export async function addNewLoanToBorrower(params: ModifiedCreateNewLoanParams) {
  const newLoanParams = modifyCreateLoanParams(params);
  // API errors will propagate up to the caller
  const res = await createNewLoan(newLoanParams);

  // Setting the cookie and reloading indicates to the backend to route to the borrower app
  utils.cookieUtils.set('selectedProductId', res.loanId, { path: '/' });
  WindowWrapper.location.reload();
}
